import HTTP from '../common/http-common';

const END_POINT = '/model';

const listModel = () => HTTP.get(END_POINT);

const isExistModelCode = (modelCode, modelId) => HTTP.get(END_POINT +  "/exist", {
    cache: false,
    params: {
        modelCode: modelCode,
        modelId: modelId
    }
});
const insertModel = (data) => HTTP.post(END_POINT, {
    modelCode: data.modelCode,
    modelName: data.modelName,
    brandCode: data.brandCode
});
const updateModel = (data) => HTTP.post(END_POINT + "/" + data.modelId, {
    modelCode: data.modelCode,
    modelName: data.modelName,
    brandCode: data.brandCode
});

const deleteModel = (modelId) => HTTP.delete(END_POINT + "/" + modelId);

export {
    listModel,
    isExistModelCode,
    insertModel,
    updateModel,
    deleteModel
}